<div class="content-section">
  <div class="titles-wrapper">
    <div class="title-container">
      <!-- <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Color de filtro</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-switch-sm form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="tool.integration.defaultmode.regular"
            (change)="getDefaultModeRegularColor()" />
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.integration.defaultmode.regular"
            [value]="tool.integration.defaultmode.regular"
            [style.background]="tool.integration.defaultmode.regular"
            [(colorPicker)]="tool.integration.defaultmode.regular" />
        </div>
      </div> -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <button class="btn-secondary-action" (click)="fillAll()">Fill All - Default values</button>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Filtered:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.filtered"
            [value]="tool.colors.filtered"
            [style.background]="tool.colors.filtered"
            [(colorPicker)]="tool.colors.filtered" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Filtered Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input class="input-colorpicker ms-2" [(ngModel)]="tool.colors.opacity" [value]="tool.colors.opacity" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Filtered Stroke:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.stroke"
            [value]="tool.colors.stroke"
            [style.background]="tool.colors.stroke"
            [(colorPicker)]="tool.colors.stroke" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Filtered Stroke Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.strokeOpacity"
            [value]="tool.colors.strokeOpacity" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Filtered Line Width:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input class="input-colorpicker ms-2" [(ngModel)]="tool.colors.lineWidth" [value]="tool.colors.lineWidth" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Hover:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.hover"
            [value]="tool.colors.hover"
            [style.background]="tool.colors.hover"
            [(colorPicker)]="tool.colors.hover" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Hover Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.hoverOpacity"
            [value]="tool.colors.hoverOpacity" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Hover Stroke:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.hoverStroke"
            [value]="tool.colors.hoverStroke"
            [style.background]="tool.colors.hoverStroke"
            [(colorPicker)]="tool.colors.hoverStroke" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Hover Stroke Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.hoverStrokeOpacity"
            [value]="tool.colors.hoverStrokeOpacity" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Hover Line Width:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.hoverLineWidth"
            [value]="tool.colors.hoverLineWidth" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Unavailable:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.unavailable"
            [value]="tool.colors.unavailable"
            [style.background]="tool.colors.unavailable"
            [(colorPicker)]="tool.colors.unavailable" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Unavailable Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.unavailableOpacity"
            [value]="tool.colors.unavailableOpacity" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Unavailable Stroke:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.unavailableStroke"
            [value]="tool.colors.unavailableStroke"
            [style.background]="tool.colors.unavailableStroke"
            [(colorPicker)]="tool.colors.unavailableStroke" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Unavailable Stroke Opacity:</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colors.unavailableStrokeOpacity"
            [value]="tool.colors.unavailableStrokeOpacity" />
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Multiple Filters</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-switch-sm form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="tool.multipleFilters"
            [checked]="tool.multipleFilters" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Estructura del menú</p>
        <div class="d-flex align-items-center">
          <div id="createnew" class="btn-secondary-wrapper me-2">
            <button
              type="button"
              class="btn-action-icon"
              (click)="toggleGenerationMode('create')"
              [ngClass]="{ active: generationMode.mode === 'create' }">
              <img src="/assets/img/icons/plus-white.svg" />
            </button>
          </div>
          <div class="form-check form-switch">
            <input
              class="input-switch-sm form-check-input"
              type="checkbox"
              role="switch"
              [(ngModel)]="previewFiltering.show"
              [checked]="previewFiltering.show" />
          </div>
        </div>
      </div>
      <div [hidden]="!previewFiltering.show" class="filter-preview-wrapper mt-4">
        <app-filter-previewitem
          #previewitem
          [activeId]=""
          [list]="itemList"
          (updatedPositionItem)="moveItem($event)"
          (editedItem)="editItem($event)"></app-filter-previewitem>
      </div>
    </div>
  </div>
  <div class="modal-wrapper" [ngClass]="{ slideup: generationMode.mode }">
    <div class="w-100 p-2">
      <app-filter-create-edit
        *ngIf="generationMode.mode"
        [tool]="tool"
        [mode]="generationMode.mode"
        [filteringItems]="{ new: newFilter, edit: itemToEdit }"
        (savedItem)="savedItem($event)"
        (cancelItem)="cancelItem($event)"></app-filter-create-edit>
    </div>
  </div>
</div>
